export default __webpack_public_path__ + "static/media/mba-leader-hijab-v1.2ba859ab.png";